import React, { Fragment, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';

const NavigationItem = ({ links = [], contentLink = null }) => {
    const menuRef = useRef(null);
    const {
        innerWidth
    } = useSelector((state) => state.browserSize);

    const toggleMenu = (e) => {
        e.preventDefault();
        const menu = menuRef.current;
        if (!menu) return;
        
        let overlay = document.querySelector('.navbar__overlay');
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.className = 'navbar__overlay';
            document.body.appendChild(overlay);
            overlay.addEventListener('click', () => {
                menu.classList.remove('navbar__menu--show');
                menu.classList.add('navbar__menu--hide');
                overlay.classList.remove('navbar__overlay--show');
            });
        }
        
        if (menu.classList.contains('navbar__menu--show')) {
            menu.classList.remove('navbar__menu--show');
            menu.classList.add('navbar__menu--hide');
            overlay.classList.remove('navbar__overlay--show');
        } else {
            menu.classList.remove('navbar__menu--hide');
            menu.classList.add('navbar__menu--show');
            overlay.classList.add('navbar__overlay--show');
            
            // Clone language selector when menu opens
            if (innerWidth <= 1128) {
                const languageSelector = document.getElementById('language-selector');
                const languageSelectorMobile = document.getElementById('language-selector-mobile');
                if (languageSelector && languageSelectorMobile) {
                    languageSelectorMobile.innerHTML = '';
                    const clone = languageSelector.cloneNode(true);
                    clone.id = '';
                    clone.className = 'language-selector-mobile';
                    languageSelectorMobile.appendChild(clone);
                }
            }
        }
    };
    
    const toggleSubmenu = (e) => {
        e.preventDefault();
        const clickedArrow = e.target;
        const clickedHeader = clickedArrow.parentElement;
        const clickedSubmenu = clickedHeader.nextSibling;
        
        // Find the clicked submenu element
        let menuItem = clickedSubmenu;
        while (menuItem && menuItem.nodeType != 1) {
            menuItem = menuItem.nextSibling;
        }
        
        if (clickedArrow.classList.contains("rotatePlus90deg")) {
            // Closing the clicked menu
            clickedArrow.classList.remove("rotatePlus90deg");
            clickedArrow.classList.add("rotateMinus90deg");
            if (menuItem) {
                menuItem.classList.remove("navbar__menu--relative");
            }
        } else {
            // Opening the clicked menu - close all siblings first
            const parentList = clickedHeader.parentElement.parentElement;
            const allItems = parentList.querySelectorAll('.navbar__item');
            allItems.forEach(item => {
                const arrow = item.querySelector('.navbar__icon--caret-right');
                const submenu = item.querySelector('.navbar__menu');
                if (arrow && arrow !== clickedArrow) {
                    arrow.classList.remove("rotatePlus90deg");
                    arrow.classList.add("rotateMinus90deg");
                }
                if (submenu && submenu !== menuItem) {
                    submenu.classList.remove("navbar__menu--relative");
                }
            });
            
            // Open the clicked menu
            clickedArrow.classList.add("rotatePlus90deg");
            clickedArrow.classList.remove("rotateMinus90deg");
            if (menuItem) {
                menuItem.classList.add("navbar__menu--relative");
            }
        }
    };
    const toggleMenuLevelThree = (e) => {
        e.preventDefault();
        if (e.target.classList.contains("rotatePlus90deg")) {
            e.target.classList.remove("rotatePlus90deg");
            e.target.classList.add("rotateMinus90deg");
            let menuItem = e.target.nextSibling;
            while (menuItem && menuItem.nodeType != 1 && !menuItem.classList.contains("navbar__menu-1")) {
                menuItem = menuItem.nextSibling;
            }
            if (menuItem && menuItem.classList) {
                menuItem.classList.remove("navbar__menu--relative");
                menuItem.classList.remove("expanded");
            }
        } else {
            e.target.classList.add("rotatePlus90deg");
            e.target.classList.remove("rotateMinus90deg");
            let menuItem = e.target.nextSibling;
            while (menuItem && menuItem.nodeType != 1 && !menuItem.classList.contains("navbar__menu-1")) {
                menuItem = menuItem.nextSibling;
            }
            if (menuItem && menuItem.classList) {
                menuItem.classList.add("navbar__menu--relative");
                menuItem.classList.add("expanded");
            }
        }
    };
    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;

    useEffect(() => {
        if (innerWidth <= 1128 && menuRef.current && contentLink && contentLink.level > 0) {
            menuRef.current.classList.remove("navbar__menu--relative");
        }
    }, [innerWidth, contentLink])

    return (
        <Fragment>
            {!contentLink ? (
                links.length > 0 &&
                <a
                    className="navbar__link--block navbar__icon--menu navbar__icon"
                    onClick={toggleMenu}
                    rel="nofollow"
                    href="#"
                    title={translate('general.menu') || 'menu'}
                >
                </a>
            ) : (
                <Fragment>
                    {innerWidth <= 1128 && links.length > 0 ? (
                        <div className="navbar__item-header">
                            {contentLink.url
                                ?
                                <a
                                    className={`navbar__link ${selectedClass} ${hasChildrenClass || ''
                                        } ${additionClass || ''}`}
                                    href={contentLink.url}
                                    dangerouslySetInnerHTML={{ __html: contentLink.name }}
                                ></a>
                                :
                                <p
                                    className={`navbar__link ${selectedClass} ${hasChildrenClass || ''
                                        } ${additionClass || ''}`}
                                    dangerouslySetInnerHTML={{ __html: contentLink.name }}
                                ></p>
                            }
                            <i
                                className={`navbar__icon navbar__icon--caret-right ${contentLink ? "navbar__icon--extraPadding" : ""}`}
                                onClick={toggleSubmenu}
                            ></i>
                        </div>
                    ) : (
                        <Fragment>
                            {contentLink.url
                                ?
                                <a
                                    className={`navbar__link ${selectedClass} ${hasChildrenClass || ''
                                        } ${additionClass || ''}`}
                                    href={contentLink.url}
                                    dangerouslySetInnerHTML={{ __html: contentLink.name }}
                                ></a>
                                :
                                <p
                                    className={`navbar__link ${selectedClass} ${hasChildrenClass || ''
                                        } ${additionClass || ''}`}
                                    dangerouslySetInnerHTML={{ __html: contentLink.name }}
                                ></p>
                            }
                        </Fragment>
                    )}
                </Fragment>
            )}

            {links.length > 0 && (
                <div className={`navbar__menu navbar__menu-${contentLink?.level}`} ref={menuRef}>
                    {contentLink !== null && contentLink.level === 0 &&
                        <Fragment>
                            <span className='navbar__menu--arrow'></span>
                        </Fragment>
                    }
                    <div className={`${contentLink ? "navbar__menu-header-hide" : "navbar__menu-header"} `}>
                        {!contentLink ? (
                            <Fragment>
                                <span
                                    className="navbar__title"
                                >{translate('general.menu') || 'menu'}</span>
                                <span
                                    className="navbar__icon navbar__icon--close"
                                    onClick={toggleMenu}
                                ></span>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <a
                                    className="navbar__title"
                                    dangerouslySetInnerHTML={{
                                        __html: contentLink.name,
                                    }}
                                    href={contentLink.url}
                                ></a>
                            </Fragment>
                        )}
                    </div>
                    {contentLink && contentLink.level === 0 && (
                        <div className="navbar__back" style={{display: 'none'}}></div>
                    )}
                    <ul className="navbar__menu-links">
                        {links.length > 0 &&
                            links.map(
                                (link, index) =>
                                    hasNameOrChildren(link) && (
                                        <li
                                            className={`navbar__item navbar__item-${contentLink === null ? "none" : contentLink.level} ${link && link.url ? "" : "default-cursor"}`}
                                            key={index}
                                        >
                                            <NavigationItem
                                                links={link.links}
                                                contentLink={link}
                                            />
                                        </li>
                                    )
                            )}
                    </ul>
                    {!contentLink && innerWidth <= 1128 && (
                        <div id="language-selector-mobile"></div>
                    )}
                </div>
            )}
        </Fragment>
    );
};

export default NavigationItem;
